/* ==========================================================================
   TOWN PDP — size-image swap, buy-bar CTA, live price/size labels.
   Uses window.Town. Does not reimplement scroll lock, accordion, or cutoff.
   ========================================================================== */
(function () {
  'use strict';

  function root() {
    return document.querySelector('[data-town-pdp]');
  }

  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents);
      } catch (e) {
        /* fall through */
      }
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function sizeLabelFromOption(value) {
    if (!value) return '';
    var raw = String(value)
      .toLowerCase()
      .replace(/inch|in\.|″|\"|in/g, '');
    var parts = raw.split('x');
    var length = parts.length >= 2 ? parseInt(String(parts[parts.length - 1]).trim(), 10) : 0;
    if (!length || length >= 500) return value;
    return length + ' in';
  }

  function leadImg() {
    var gallery = document.querySelector('.thb-product-detail .product-images');
    if (!gallery) return null;
    return (
      gallery.querySelector('.product-images__slide.is-selected img') ||
      gallery.querySelector('.product-images__slide.is-active img') ||
      gallery.querySelector('.product-images__slide.is-initial-selected img') ||
      gallery.querySelector('img')
    );
  }

  function rememberOriginal(img) {
    if (!img || img.dataset.townPdpOrig) return;
    img.dataset.townPdpOrig = img.currentSrc || img.src || '';
    img.dataset.townPdpOrigSrcset = img.getAttribute('srcset') || '';
    img.dataset.townPdpOrigAlt = img.getAttribute('alt') || '';
  }

  function applyImage(img, src, srcset, alt) {
    if (!img || !src) return;
    var probe = new Image();
    probe.onload = function () {
      img.src = src;
      if (srcset) img.setAttribute('srcset', srcset);
      else img.removeAttribute('srcset');
      if (alt) img.setAttribute('alt', alt);
    };
    probe.src = src;
  }

  function candidatesFromInput(input) {
    if (!input) return [];
    var list = [];
    if (input.getAttribute('data-size-image')) list.push(input.getAttribute('data-size-image'));
    if (input.getAttribute('data-size-cand-a')) list.push(input.getAttribute('data-size-cand-a'));
    if (input.getAttribute('data-size-cand-b')) list.push(input.getAttribute('data-size-cand-b'));
    return list;
  }

  function swapForInput(input) {
    var img = leadImg();
    if (!img || !input) return;
    rememberOriginal(img);
    var srcset = input.getAttribute('data-size-srcset') || '';
    var alt = input.getAttribute('data-size-alt') || '';
    var list = candidatesFromInput(input);
    if (!list.length) return;

    var i = 0;
    function tryNext() {
      if (i >= list.length) return;
      var src = list[i++];
      var probe = new Image();
      probe.onload = function () {
        applyImage(img, src, i === 1 ? srcset : '', alt);
      };
      probe.onerror = tryNext;
      probe.src = src;
    }
    tryNext();
  }

  function checkedSizeInput() {
    var box = document.querySelector('[data-town-pdp-sizes]');
    if (!box) return null;
    return box.querySelector('input[type="radio"]:checked');
  }

  function syncBuybar(variant) {
    var priceEl = document.querySelector('[data-town-pdp-buybar-price]');
    var sizeEl = document.querySelector('[data-town-pdp-buybar-size]');
    if (variant && typeof variant.price === 'number' && priceEl) {
      priceEl.textContent = money(variant.price);
    }
    if (variant && sizeEl) {
      var opt = variant.option1 || variant.title || '';
      sizeEl.textContent = sizeLabelFromOption(opt);
    }
  }

  function syncFromDom() {
    var input = checkedSizeInput();
    if (!input) return;
    swapForInput(input);
    var cents = parseInt(input.getAttribute('data-variant-price'), 10);
    syncBuybar({
      price: isNaN(cents) ? null : cents,
      option1: input.value
    });
  }

  function decorateUploadCta() {
    var wrap = root();
    if (!wrap || wrap.getAttribute('data-town-pdp-flow') !== 'upload') return;
    var cta = document.getElementById('town-pdp-cta');
    if (!cta) return;
    var btn = cta.querySelector('.gs--button, a, button, [type="submit"]');
    if (!btn) return;
    btn.classList.add('town-btn', 'town-btn--primary', 'town-btn--block');
  }

  function decorateAppCta() {
    var app = document.querySelector('.town-pdp-app');
    if (!app) return;
    var real = app.querySelector('a, button, .gs--button');
    if (real) {
      real.classList.add('town-pdp-app__action');
      return;
    }
    var i;
    for (i = 0; i < app.children.length; i++) {
      var el = app.children[i];
      if (el.tagName === 'INPUT' || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') continue;
      el.classList.add('town-pdp-app__action');
      return;
    }
  }

  function onBuybarClick(e) {
    var trigger = e.target.closest('[data-town-buybar-cta]');
    if (!trigger) return;
    var bar = trigger.closest('[data-town-buybar]');
    var sel = bar && bar.getAttribute('data-town-buybar-watch');
    var watch = sel ? document.querySelector(sel) : null;
    if (!watch) return;
    var target = watch.matches('a, button, [type="submit"]')
      ? watch
      : watch.querySelector('a.gangsheet-btn--dtftown, .gs--button, a, button, [type="submit"]');
    if (target) {
      target.click();
      return;
    }
    // The upload flow's control is injected by the Build-a-Gang-Sheet app block,
    // so on the first paint there may be nothing to forward the click to. Scroll
    // the customer to it instead of leaving a primary CTA that does nothing.
    watch.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function optionForValue(value) {
    if (!value) return null;
    var sel = document.querySelector('[data-town-length]');
    if (!sel) return null;
    return [].find.call(sel.options, function (o) {
      return o.value === value;
    }) || null;
  }

  function applyLength(opt) {
    if (!opt) return;
    var sel = opt.parentNode;
    if (sel && sel.selectedIndex !== opt.index) sel.selectedIndex = opt.index;
    var id = opt.getAttribute('data-radio');
    var radio = id && document.getElementById(id);
    if (radio && !radio.disabled && !radio.checked) radio.checked = true;
    swapForInput(opt);
  }

  function onVariantChange(e) {
    var variant = e.detail && e.detail.variant;
    var opt = variant && optionForValue(variant.option1 || variant.title);
    if (opt) applyLength(opt);
    else syncLengthSelect();
    syncBuybar(variant);
  }

  /* --- Length select -> real radio -----------------------------------------
     The visible control is a <select>, but the form contract and the theme's
     variant machinery run on the radios that town-pdp-sizes.liquid keeps hidden
     in the DOM. Mirror the choice onto the matching radio and let the theme's
     own change handler do the rest, so price, availability, the app block and
     the gallery swap all stay on one code path.
  ----------------------------------------------------------------------- */
  function onLengthSelect(e) {
    var sel = e.target.closest ? e.target.closest('[data-town-length]') : null;
    if (!sel) return;
    applyLength(sel.options[sel.selectedIndex]);
  }

  // Keep the select honest if the variant is changed by anything else
  // (browser back, the app block, a deep link with ?variant=).
  function syncLengthSelect() {
    var radio = checkedSizeInput();
    if (!radio) return;
    document.querySelectorAll('[data-town-length]').forEach(function (sel) {
      var opt = [].find.call(sel.options, function (o) {
        return o.getAttribute('data-radio') === radio.id;
      });
      if (opt && sel.selectedIndex !== opt.index) sel.selectedIndex = opt.index;
    });
  }

  function boot(scope) {
    decorateUploadCta();
    decorateAppCta();
    syncFromDom();
    if (window.Town && typeof window.Town.initAll === 'function' && scope) {
      window.Town.initAll(scope);
    }
  }

  document.addEventListener('click', onBuybarClick);
  document.addEventListener('change', onLengthSelect);
  document.addEventListener('product:variant-change', onVariantChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
